import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function SafeDrivingIrrecoverableBottomSheetLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet skeleton">
      <div className="bottom_sheet_header">
        <h2
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T20175_$score', {score: 99})}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20176_$discount', {discount: 12})}</strong>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('T20177')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_outline"
          >
            {t('T20178')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SafeDrivingIrrecoverableBottomSheetLoadingKr;
